<template>
  <div class="speedometer">
    <AnimatedNumber
      :duration="duration"
      :format-value="formatFixed"
      :value="value" />
    <div>km/h</div>
  </div>
</template>

<script>
import AnimatedNumber from 'animated-number-vue'
export default {
  name: 'Speedometer',
  components: {
    AnimatedNumber
  },
  props: {
    value: {
      type: Number,
      required: true,
      default: () => 0
    }
  },
  data() {
    return {
      duration: 1500
    }
  },
  watch: {
    value(current, old) {
    }
  },
  mounted() {
  },
  methods: {
    formatFixed(value) {
      return `${value.toFixed(0)}`
    }
  }
}
</script>

<style>

.speedometer {
  background: white;
  border-radius: 20px;
  padding-top: 10px;
  width: 120px;
  opacity: 0.95;
  filter: drop-shadow(0px 5px 24px lightgrey);
  color: var(--color);
  text-align: center;
}

.speedometer span {
  line-height: 80%;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0.01em;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;

/* Regent Gray */

color: #898C94;
}

.speedometer div {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  margin-top: 4px;
  padding-bottom: 10px;
  /* identical to box height */

  text-align: center;

  color: #A9B3DC;
}
</style>
